import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const exitTopologyPresetEditMode: GraphCommandFactory =
  (cmdContext) => () => {
    cmdContext.updateState((draft) => {
      draft.layoutSettings.presetEditMode = false;
    });
  };
